export const SAVE_RESPONSES_PAYLOAD = "SAVE_RESPONSES_PAYLOAD";
export const RESET_RESPONSES_PAYLOAD = "RESET_RESPONSES_PAYLOAD";
